function closeNav() {
    var element = document.getElementById("ipjSidebar");
    if(element) {
        element.classList.toggle("sidebar__closed");
    }
    var mainEle = document.getElementById("wrapper__section");
    if(mainEle) {
        mainEle.classList.toggle("main-section--margin");
    }var mainEle = document.getElementById("header");
    if(mainEle) {
        mainEle.classList.toggle("main-section--margin");
    }
    var habdrillBanner = document.getElementById("habit-drill-banner");
    if (habdrillBanner) {
      habdrillBanner.classList.toggle("banner-box__sidenav--close")
    }
    var habdrillCards = document.getElementById("hd-activity-cards");
    if (habdrillCards) {
      habdrillCards.classList.toggle("hd-activity__sidenav--close")
    }
    var habdrillCards = document.getElementById("hd-last__right");
    if (habdrillCards) {
      habdrillCards.classList.toggle("hd-last__sidenav--close")
    }
    // if (window.matchMedia('only screen and (min-width: 768px) and (max-width: 1024px)').matches) {
    //     if(mainEle) {
    //         mainEle.classList.toggle('main-section--margin');
    //     }
    // }
}
function closeNavMobile() {
    var element = document.getElementById("ipjSidebar");
    if(element) {
        element.classList.toggle("hide-on-mobile");
    }
    var element2 = document.getElementById("siderbar__overlay");
    if(element2) {
        element2.classList.toggle("d-none");
    }
    var element3 = document.getElementById("wrapper__section");
    if(element3) {
        element3.classList.remove("position-fixed");
    }
    var element4 = document.getElementById("iconNavMobile");
    if(element4) {
        element4.classList.toggle("icon-open");
    }
}
// (function () {
//     window.onload = function () {
//         var totalProgress, progress;
//         const circles = document.querySelectorAll('.progress__bar--svg');
//         for (var i = 0; i < circles.length; i++) {
//             totalProgress = circles[i].querySelector('circle').getAttribute('stroke-dasharray');
//             progress = circles[i].parentElement.getAttribute('data-percent');

//             circles[i].querySelector('.progress__bar--circlePercentage').style['stroke-dashoffset'] = totalProgress * progress / 100;

//         }
//     }
// })();

// // for mark as complete button in submission to show textarea
// var getButton = document.querySelector(".hd-submission__banner button");
// var getEl = document.querySelector(".hd-mark-complete");

// getButton.addEventListener("click", function () {
//     getEl.style.display = "block";
//     getEl.classList.toggle("hd-mark-complete__show")
// });
// function openTab(evt, cityName) {
//     // Declare all variables
//     var i, tabcontent, tablinks;
//     // Get all elements with class="tabcontent" and hide them
//     tabcontent = document.getElementsByClassName("notes__bookmarks--tabcontent");
//     for (i = 0; i < tabcontent.length; i++) {
//         tabcontent[i].style.display = "none";
//     }
//     // Get all elements with class="tablinks" and remove the class "active"
//     tablinks = document.getElementsByClassName("tablinks");
//     for (i = 0; i < tablinks.length; i++) {
//         tablinks[i].className = tablinks[i].className.replace(" active", "");
//     }
//     // Show the current tab, and add an "active" class to the button that opened the tab
//     document.getElementById(cityName).style.display = "block";
//     evt.currentTarget.className += " active";
// }

// var accItem = document.getElementsByClassName('accordion__item');
// var accHD = document.getElementsByClassName('accordion__item--header');
// for (j = 0; j < accHD.length; j++) {
//     accHD[j].addEventListener('click', toggleItem, false);
// }
// function toggleItem() {
//     var itemClass = this.parentNode.className;
//     for (j = 0; j < accItem.length; j++) {
//         accItem[j].className = 'accordion__item close--accordion';
//     }
//     if (itemClass == 'accordion__item close--accordion') {
//         this.parentNode.className = 'accordion__item open--accordion';
//     }
// }
window.onload = function () {

    var modal = document.getElementById("feedback__Modal");

    // Get the button that opens the modal
    var btn = document.getElementById("myBtn");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on the button, open the modal
    // btn.onclick = function () {
    //     modal.style.display = "flex";
    // }

    //When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }


    const instagram = document.getElementById("instagram");

    function addAnimation(buttonNumber, animationNumber, path) {
        const buttonX = document.getElementById(buttonNumber);
        const XAnimation = document.getElementById(animationNumber);

        const animItemX = bodymovin.loadAnimation({
            wrapper: XAnimation,
            animType: "svg",
            loop: false,
            autoplay: false,
            path: path,
        });

        if(buttonX) {
            buttonX.addEventListener("click", () => {
                XAnimation.classList.remove("hide");
                animItemX.goToAndPlay(0, true);
            });
        }

        animItemX.addEventListener("complete", () => {
            XAnimation.classList.add("hide");
        });
    }
    addAnimation(
        "buttonThree",
        "thirdAnimation",
        "https://assets2.lottiefiles.com/packages/lf20_pkanqwys.json"
    );

    const instagramAnimation = bodymovin.loadAnimation({
        wrapper: instagram,
        animType: "svg",
        loop: true,
        autoplay: true,
        path: "https://assets8.lottiefiles.com/private_files/lf30_igdzkfxv.json",
    });

}
// popup

/*window.onload = function () {
    var modal_popup = document.querySelector(".popup-main");
    var popup_btn = document.querySelector(".popup__show");
    var popup_btn1 = document.getElementById("popup__show--mob");
    var popup_close = document.getElementsByClassName("popup--close")[0];

    popup_btn.onclick = function () {
        modal_popup.style.display = "block";
    }
    popup_btn1.onclick = function () {
        modal_popup.style.display = "block";
    }

    popup_close.onclick = function () {
        modal_popup.style.display = "none";
    }

    popup_close.onclick = function () {
        modal_popup.style.display = "none";
    }
}*/

// added in ts file can be deleted
function viewPassword() {
    var passwordInput = document.getElementById('password-field');
    var passStatus = document.getElementById('password--status');

    if (passwordInput.type == 'password') {
        passwordInput.type = 'text';
        passStatus.className = 'password--icon icon-eye';

    }
    else {
        passwordInput.type = 'password';
        passStatus.className = 'password--icon icon-eye-blocked';
    }
}
function viewResetPassword() {
    var passwordInput = document.getElementById('password-field1');
    var passStatus = document.getElementById('password--status1');

    if (passwordInput.type == 'password') {
        passwordInput.type = 'text';
        passStatus.className = 'password--icon icon-eye cursor-pointer';

    }
    else {
        passwordInput.type = 'password';
        passStatus.className = 'password--icon icon-eye-blocked cursor-pointer';
    }
}

function viewOldPassword() {
    var passwordInput = document.getElementById('password-field2');
    var passStatus = document.getElementById('password--status2');

    if (passwordInput.type == 'password') {
        passwordInput.type = 'text';
        passStatus.className = 'password--icon icon-eye cursor-pointer';

    }
    else {
        passwordInput.type = 'password';
        passStatus.className = 'password--icon icon-eye-blocked cursor-pointer';
    }
}

// custom dropdown with search functionality



// var getBtn = document.querySelector(".dropbtn");
// var getLI = document.querySelector("ul");
// var getDiv = document.getElementById("myDropdown");
// var getInput = document.getElementById("myInput");

// if (getBtn) {
//     getBtn.addEventListener("click", function (e) {
//         e.preventDefault();
//         this.classList.toggle("active__arrow");
//         getDiv.classList.toggle("show");
//         return false;
//     });
// }
// // var html = document.querySelector("body");
// // html.addEventListener("click", function (e) {
// //     if (e.target !== getBtn && e.target !== getInput) {
// //         getBtn.classList.remove("active__arrow");
// //         getDiv.classList.remove("show");
// //     }
// // });
// function getEventTarget(e) {
//     e = e || window.event;
//     return e.target || e.srcElement;
// }
// // filter
// function filterFunction() {
//     var filter, a, i;
//     filter = getInput.value.toUpperCase();
//     a = getDiv.getElementsByTagName("li");
//     for (i = 0; i < a.length; i++) {
//         txtValue = a[i].textContent || a[i].innerText;
//         if (txtValue.toUpperCase().indexOf(filter) > -1) {
//             a[i].style.display = "";

//         } else {
//             a[i].style.display = "none";
//         }
//     }
// }
// // get value from li
// getLI.onclick = function (event) {
//     var target = getEventTarget(event);
//     var v = target.getAttribute("data-code");
//     getBtn.textContent = v;
// };

// ribbon popup
document.addEventListener('DOMContentLoaded', function () {
    var getPopupDiv = document.getElementsByClassName("program-comp__popup");
    for (var pop = 0; pop <= getPopupDiv.length - 1; pop++) {
        getPopupDiv[pop].classList.add("showRibbon")
    }
});

function takeawaysToggle() {
    var element = document.getElementById("viewless");
    element.classList.toggle("d-none");

    var element1 = document.getElementById("viewmore");
    element1.classList.toggle("d-none");
}